<template>
  <div class="activity-nav-list">
    <div class="new-center-content">
      <div class="new-center-top fl">
        <div class="new-top-nav" :style="{background:'url('+imgs+')'}">
          <h1 class="new-top-title fl">A</h1>
          <div class="fl" style="padding-left:4px;">
            <p class="new-top-navtitle">认证活动</p>
            <p class="new-top-ews">ctivity</p>
          </div>
        </div>
        <div class="new-center-tab">
          <div
            class="new-center-dynamic"
            v-for="(item,index) in activityData"
            :key="index"
            @click="tabShow(index+1)"
            :class="{'class-back':isTab == index+1 }"
          >
            {{item}}
            <span class="wl-icon wl-icon-xiangyou fr"></span>
          </div>
        </div>
      </div>
      <div class="new-breadcrumb-trail">
        <h2>新闻动态</h2>
        <div class="crumbs-text">
          <i class="wl-icon-zhuye1"></i>
          <span>当前位置：</span>
          <span @click="goHome">网站首页</span>
          <span>></span>
          <span @click="goActiv">{{activityData[isTab-1]}}</span>
          <span>></span>
          <span>{{attestationInfo.Title}}</span>
        </div>
      </div>
      <div class="new-center-detail">
        <div class="new-center-title">
          <h3 class="h3-news-title">{{attestationInfo.Title}}</h3>
          <p class="p-news-date">
              <span v-if="attestationInfo.SiteName!=''">来源：{{attestationInfo.SiteName}}</span>
              <span v-else>来源:系统管理员</span>
              <span style="margin-left:100px;">发布时间：{{attestationInfo.PulishTime}}</span>
          </p>
          <div class="class-news-content">
            <p v-html="attestationInfo.Content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        activityData: ["站点活动", "讲师培训", "学员培训", "考证信息"],
        imgs:require("../../assets/images/bg-hd.png"),
        imgcen:require("../../assets/images/hn-news-1.png"),
        isTab:1,
        attestationInfo:[],
    };
  },
  created() {
      if (this.$route.params.isTab == undefined) {
          this.isTab = 1
      } else {
          this.isTab = this.$route.params.isTab;
      }
    this.getAttestationInfo();
  },
  props:{
    activityId:{
      type:String,
      default:""
    }
  },
  methods: {
    tabShow(num) {
      this.isTab = num;
      this.$router.push({
        name: "certifiActiv",
         params:{
          isTab:this.isTab
        }
      });
    },
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    //获取活动详情
    getAttestationInfo(){
      var that = this;
      this.$http.post(
        '/api/XOrg/AttestationActivity/getAttestationInfo',
        {
          Id: that.activityId
        }
      )
      .then(rst =>{
        if(rst.code ==1){
          that.attestationInfo= rst.attestationInfo
        }else {
          that.$message.warning(rst.msg);
        }
      });
    },
    goActiv() {
      this.$router.push({
        name: "certifiActiv",
         params:{
          isTab:this.isTab
        }
      });
    },
  }
};
</script>
